import { useEffect, useState } from "react";
import { ROUTES } from "@constants";
import { useHistory } from "react-router-dom";
import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { getProspectReference } from "@utils/storage";
import { keycloakUtils } from "itsf-ui-common";
import { useFetchState } from "@hooks/useFetchState";
import { getCustomerDetails as fetchCustomerDetailsFromApi } from "@modules/eirSalesFacade/apis/getCustomerDetails";
import { getContactDetails } from "@modules/eirSalesFacade/apis/getContactDetails";

export const useGetCustomerDetails = () => {
    const { push } = useHistory();
    const [customerDetails, setCustomerDetails] = useState<ICustomerDetails>();
    const { startFetching, endFetching, error, isLoading } = useFetchState();

    const fetchContactDetails = async () => {
        const userProfile = await keycloakUtils.getUserProfile();
        const contactUuid = userProfile?.username;
        if (contactUuid) {
            try {
                const customerDetailsResult = await getContactDetails(contactUuid);
                if (customerDetailsResult) {
                    setCustomerDetails(customerDetailsResult);
                }
                endFetching();
            } catch (apiError) {
                endFetching(apiError);
            }
        } else {
            push(ROUTES.BASE_URL);
        }
    };

    const fetchCustomerDetails = () => {
        const isAuthenticated = keycloakUtils.isAuthenticated();
        startFetching();
        if (isAuthenticated) {
            fetchContactDetails();
        } else {
            const prospectReference = getProspectReference();
            if (prospectReference) {
                fetchCustomerDetailsFromApi()
                    .then((customerDetailsResult) => {
                        if (customerDetailsResult) {
                            setCustomerDetails(customerDetailsResult);
                        }
                        endFetching();
                    })
                    .catch((apiError) => {
                        endFetching(apiError);
                    });
            } else {
                push(ROUTES.BASE_URL);
            }
        }
        endFetching();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(fetchCustomerDetails, []);

    return {
        customerDetails,
        getCustomerDetailsState: {
            isLoading,
            error,
        },
        getCustomerDetails: fetchCustomerDetails,
        setCustomerDetails,
    };
};
